export default __webpack_public_path__ + "static/media/EuclidCircularA-Bold.345dea3e.ttf";